import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  CircularProgress,
  Stack,
  Chip,
  Button,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { ENDPOINT } from "../../../endpoints/endpoints";

const Group_detail = () => {
  const { id } = useParams(); // get group id from URL
  const navigate = useNavigate();

  const [group, setGroup] = useState(null);
  const [loading, setLoading] = useState(true);

  // ---------------- Fetch Group Detail ----------------
  const fetchGroupDetail = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.get(ENDPOINT.GROUP_DETAIL(id), {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success) {
        setGroup(response.data.group);
      } else {
        alert("Failed to fetch group details");
      }
    } catch (error) {
      console.error("Error fetching group detail:", error);
      alert(
        error.response?.data?.message || "Something went wrong while fetching group detail"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroupDetail();
  }, [id]);

  // ---------------- UI ----------------
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={5}>
        <CircularProgress />
      </Box>
    );
  }

  if (!group) {
    return (
      <Container maxWidth="sm" sx={{ mt: 5 }}>
        <Typography variant="h6" color="text.secondary">
          Group not found.
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Paper sx={{ p: 4, borderRadius: 2 }}>
        <Stack spacing={3}>
          <Typography variant="h5">Group Detail</Typography>

          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              ID
            </Typography>
            <Typography variant="body1">{group.id}</Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Name
            </Typography>
            <Typography variant="body1">{group.name}</Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Permissions
            </Typography>
            {group.permissions?.length > 0 ? (
              <Stack direction="row" spacing={1} flexWrap="wrap">
                {group.permissions.map((perm) => (
                  <Chip key={perm} label={perm} size="small" />
                ))}
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No permissions
              </Typography>
            )}
          </Box>

          <Box mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/groups/list")}
            >
              Back to Group List
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Container>
  );
};

export default Group_detail;